
<div class="sign-incomplete">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2>Sign In Almost Complete</h2>
      <h5>Ordering and Rewards needs more info to better serve you.</h5>
    </div>
  </div>
  <div class="row mg-top-24">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <app-alert [alertService]="alertService"></app-alert>
    </div>
      <form (ngSubmit)="onSubmit()" [formGroup]="signInIncompleteForm" >
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group" *ngIf="!externalUserProfile?.firstName"> 
                  <label>First Name</label>
                  <input type="firstName" value="externalUserProfile.firstName" class="form-control" formControlName="firstName"/>
                <app-validation-message [control]="signInIncompleteForm.controls.firstName" class="form-error"></app-validation-message>
                
              </div>
              <div class="form-group" *ngIf="externalUserProfile?.firstName">
                <b>First Name</b>
                <p>{{externalUserProfile?.firstName}}</p>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group" *ngIf="!externalUserProfile?.lastName">                                  
                  <label>Last Name</label>
                  <input type="lastName" value="externalUserProfile.lastName" class="form-control" formControlName="lastName"/>
                <app-validation-message [control]="signInIncompleteForm.controls.lastName" class="form-error"></app-validation-message>                
              </div>
              <div class="form-group" *ngIf="externalUserProfile?.lastName">
                <b>Last Name</b>
                <p>{{externalUserProfile?.lastName}}</p>
              </div>
            </div>
          </div>
          <div class="row" *ngIf ="!externalUserProfile.email">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                  <label>Email Address</label>
                  <input type="email" value="externalUserProfile.email" class="form-control" formControlName="email" maxlength="50" />
                  <app-validation-message [control]="signInIncompleteForm.controls.email" class="form-error"></app-validation-message>
              </div>
            </div>
          </div>
          <div class="row mg-top-12">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <button type="submit" [disabled]="!signInIncompleteForm.valid" class="btn wb-btn-default center-block">
                Complete Sign In
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="row clear-div">
        <div class="col-md-12 text-center mg-top-15">
          <span role="button" class="forget-sign-link" (click)="childClosed()">Sign In Later</span>
          <span class="hint-text-1 mg-top-10">Ordering & Rewards will be limited.</span>
        </div>
      </div>
    </div>
</div>
